export const GET_MODIFIER_GROUPS = 'providers/menuMaker/ModifierGroups/GET_MODIFIER_GROUPS';
export const GET_PAGINATION_MODIFIER_GROUP = 'providers/menuMaker/ModifierGroups/GET_PAGINATION_MODIFIER_GROUP';
export const CREATE_MODIFIER_GROUP = 'providers/menuMaker/ModifierGroups/CREATE_MODIFIER_GROUP';
export const DELETE_MODIFIER_GROUP = 'providers/menuMaker/ModifierGroups/DELETE_MODIFIER_GROUP';
export const DUPLICATE_MODIFIER_GROUP = 'providers/menuMaker/ModifierGroups/DUPLICATE_MODIFIER_GROUP';
